import axios from "axios";

/** Set by the desktop app when it serves these pages; absent on the website. */
export const DESKTOP = window.RIVALS_DESKTOP || null;
export const isDesktop = !!DESKTOP;

// App-only routes on the app's local server. They don't exist on the website.
const http = axios.create({ baseURL: "/api/desktop", headers: DESKTOP ? { "X-Desktop-Key": DESKTOP.key } : {} });
http.interceptors.response.use((r) => r, (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === "string") error.message = detail;
  return Promise.reject(error);
});
const data = (r) => r.data;

export const desktop = {
  status: () => http.get("/status").then(data),
  setSite: (site_url) => http.put("/settings", { site_url }).then(data),
  setToken: (token) => http.put("/token", { token }).then(data),
  clearToken: () => http.delete("/token").then(data),
  setTokenSlot: (slot, token) => http.put(`/tokens/${slot}`, { token }).then(data),
  clearTokenSlot: (slot) => http.delete(`/tokens/${slot}`).then(data),
  startCapture: () => http.post("/capture/start").then(data),
  stopCapture: () => http.post("/capture/stop").then(data),
  importUids: (body) => http.post("/import", body).then(data),
  importFile: (file, fields = {}) => {
    const form = new FormData();
    form.append("file", file);
    Object.entries(fields).forEach(([k, v]) => { if (v !== "" && v !== null && v !== undefined) form.append(k, v); });
    return http.post("/import-file", form).then(data);
  },
  jobs: () => http.get("/jobs").then(data),
};
